import { useState } from "react";
import { toast } from "react-toastify";

interface IProps {
  closeModal: any;
  deletionIdentifier: any;
  messageBody: any;
  deleteAPItrigger: any;
  toastSuccessMessage?: string;
}

const DeleteModal: React.FC<IProps> = ({
  closeModal,
  deleteAPItrigger,
  deletionIdentifier,
  messageBody,
  toastSuccessMessage,
}) => {
  const confirmDeleteSchedule = async (event: any) => {
    try {
      const response = await deleteAPItrigger(deletionIdentifier);

      if (response) {
        // Check if the response contains an error
        if (response.error) {
          // Handle different error response structures
          let errorMsg = "Failed to delete. Please try again.";

          if (response.error.data) {
            // If error data is an array (like your API returns: ["Error message"])
            if (Array.isArray(response.error.data)) {
              errorMsg = response.error.data[0] || errorMsg;
            }
            // If error data is an object with a message property
            else if (response.error.data.message) {
              errorMsg = response.error.data.message;
            }
            // If error data has a detail property (common in Django REST Framework)
            else if (response.error.data.detail) {
              errorMsg = response.error.data.detail;
            }
            // If error data is an object with other properties
            else if (typeof response.error.data === "object") {
              // Try to extract the first error message from the object
              const firstError = Object.values(response.error.data)[0];
              if (Array.isArray(firstError)) {
                errorMsg = firstError[0];
              } else if (typeof firstError === "string") {
                errorMsg = firstError;
              }
            }
            // If error data is a string
            else if (typeof response.error.data === "string") {
              errorMsg = response.error.data;
            }
          }
          // Fallback to error message if available
          else if (response.error.message) {
            errorMsg = response.error.message;
          }

          toast.error(errorMsg);
          return;
        }

        // Success case
        if (response.data === true || response.data) {
          toastSuccessMessage
            ? toast.success(toastSuccessMessage)
            : toast.success("Deletion successful!");
          closeModal();
        }
      }
    } catch (error: any) {
      const errorMsg = error?.message || "An unexpected error occurred.";

      toast.error(errorMsg);
    }
  };

  return (
    <>
      <div className="card-body">
        {messageBody}
        <div className="d-flex justify-content-end mt-10">
          <button
            type="reset"
            className="btn btn-sm btn-white btn-active-light-primary me-2"
            onClick={() => closeModal()}
          >
            {" "}
            Cancel{" "}
          </button>
          <button
            type="submit"
            className="btn btn-sm btn-danger"
            onClick={confirmDeleteSchedule}
          >
            {" "}
            Delete{" "}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;